import { IconButton, Stack } from '@mui/material'
import { AccountRole } from '../../types/account-role'
import Dropdown from './Dropdown'
import AddIcon from '@mui/icons-material/Add'
import SettingsIcon from '@mui/icons-material/Settings'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Link } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import { useGetProfile } from '../../api/auth'

export default function ActionsPanel() {
  const { data: user } = useGetProfile()

  return (
    <Stack direction="row" gap={{ xs: 0, md: 2 }}>
      {user?.role === AccountRole.ADMIN && (
        <Dropdown
          icon={
            <AddIcon
              id="create-button"
              sx={{ fontSize: { xs: '20px', md: '24px' }, color: 'white' }}
            />
          }
          options={[
            { label: 'فرایند جدید', link: '/create' },
            { label: 'کاربر جدید', link: '/accounts' },
          ]}
        />
      )}
      <Dropdown
        icon={
          <SettingsIcon sx={{ fontSize: { xs: '20px', md: '24px' }, color: 'white' }} />
        }
        options={[{ label: 'تنظیمات' }, { label: 'خروج' }]}
      />
      <Dropdown
        icon={
          <NotificationsIcon
            sx={{ fontSize: { xs: '20px', md: '24px' }, color: 'white' }}
          />
        }
        options={[{ label: 'پیامی ندارید' }]}
      />
      <Link to="/">
        <IconButton>
          <HomeIcon sx={{ fontSize: { xs: '20px', md: '24px' }, color: 'white' }} />
        </IconButton>
      </Link>
    </Stack>
  )
}
